import loadable from '@loadable/component';
import type React from 'react';
import type { RouteObject } from 'react-router';
import { useRoutes } from 'react-router-dom';
import { isLlmGameMatchingAvailable, Route } from 'src/constants';

const Main = loadable(() => import('src/pages/main/main'));
const SignIn = loadable(() => import('src/pages/sign-in/sign-in'));
const UnmappedGames = loadable(() => import('src/pages/unmapped-games/unmapped-games'));
const Aliases = loadable(() => import('src/pages/aliases/aliases'));
const PossibleAliases = loadable(() => import('src/pages/possible-aliases/possible-aliases'));
const Games = loadable(() => import('src/pages/games/games'));
const MappedPromoGames = loadable(() => import('src/pages/mapped-promo-games/mapped-promo-games'));
const UnmappedPromoGames = loadable(() => import('src/pages/unmapped-promo-games/unmapped-promo-games'));
const LlmGameMatching = loadable(() => import('src/pages/llm-game-matching/llm-game-matching'));
const NotFound = loadable(() => import('src/pages/not-found/not-found'));

export const getRoutes = (): RouteObject[] => [
  {
    path: Route.MAIN,
    element: <Main />,
    caseSensitive: true,
  },
  {
    path: Route.SIGN_IN,
    element: <SignIn />,
    caseSensitive: true,
  },
  {
    path: Route.UNMAPPED_GAMES,
    element: <UnmappedGames />,
    caseSensitive: true,
  },
  {
    path: Route.ALIASES,
    element: <Aliases />,
    caseSensitive: true,
  },
  {
    path: Route.POSSIBLE_ALIASES,
    element: <PossibleAliases />,
    caseSensitive: true,
  },
  {
    path: Route.GAMES,
    element: <Games />,
    caseSensitive: true,
  },
  {
    path: Route.MAPPED_PROMO_GAMES,
    element: <MappedPromoGames />,
    caseSensitive: true,
  },
  {
    path: Route.UNMAPPED_PROMO_GAMES,
    element: <UnmappedPromoGames />,
    caseSensitive: true,
  },
  ...(isLlmGameMatchingAvailable
    ? [
        {
          path: Route.LLM_GAME_MATCHING,
          element: <LlmGameMatching />,
          caseSensitive: true,
        },
      ]
    : []),
  {
    path: Route.NOT_FOUND,
    element: <NotFound />,
    caseSensitive: true,
  },
];

export const Router: React.FC = () => useRoutes(getRoutes());
